import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"
import { useToast } from "./use-toast"
import { CheckCircle2, AlertCircle, XCircle, Info, Bell, AlertTriangle } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      <ToastViewport>
        <AnimatePresence mode="sync" initial={false}>
          {toasts.map(function ({ id, title, description, action, variant, ...props }) {
            const Icon = {
              default: Bell,
              success: CheckCircle2,
              warning: AlertTriangle,
              destructive: XCircle,
              info: Info,
            }[variant || "default"]

            return (
              <motion.div
                key={id}
                layout
                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                animate={{ 
                  opacity: 1, 
                  y: 0, 
                  scale: 1,
                  transition: {
                    type: "spring",
                    stiffness: 500,
                    damping: 30,
                    mass: 1
                  }
                }}
                exit={{ 
                  opacity: 0,
                  scale: 0.95,
                  transition: {
                    duration: 0.2
                  }
                }}
                style={{ 
                  transformOrigin: "top right",
                  willChange: "transform, opacity"
                }}
                className="pointer-events-auto"
              >
                <Toast variant={variant} {...props}>
                  <div className="grid gap-1.5">
                    <div className="flex items-center gap-2">
                      <Icon className="h-4 w-4 shrink-0 flex-none" />
                      {title && <ToastTitle>{title}</ToastTitle>}
                    </div>
                    {description && (
                      <ToastDescription className="break-words">{description}</ToastDescription>
                    )}
                  </div>
                  {action}
                  <ToastClose />
                </Toast>
              </motion.div>
            )
          })}
        </AnimatePresence>
      </ToastViewport>
    </ToastProvider>
  )
} 